import Card from '..';
import { Mission } from '@edwin-group/cj-graphql';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import { useMemo } from 'react';

export const arrowMissionImg = '/card/arrow-mission.png';

const MissionCard = ({
  mission,
  description,
  button,
}: {
  mission: Mission;
  description?: React.ReactNode;
  button?: React.ReactNode;
  link?: string;
}) => {
  const programmes = useMemo(
    () => mission?.programmes?.map((programme) => programme?.name).join(', '),
    [mission?.programmes],
  );

  return (
    <Card
      titleExtra={programmes}
      key={mission?.slug}
      title={mission?.roleModel || ''}
      descriptionHtml={description || mission?.description || ''}
      arrowImg={arrowMissionImg}
      tags={
        mission?.trait ? (
          <DefaultContentTemplateTags type="MISSION" traitTags={[mission?.trait]} className="!mb-2 !mt-0" />
        ) : null
      }
      image={{
        url: mission?.cover?.url || '',
        alternativeText: mission?.cover?.alternativeText || '',
      }}
      button={button}
    />
  );
};

export default MissionCard;
